import React, { useContext, useState } from "react";
import { State } from "../context/State";
import { LibraryLayer } from "../models/LibraryLayer";
import { countries } from "../target/output";
import LibraryCard from "./LibraryCard";
import Link from "./Link";
import { getLayer } from "./util";
import * as _ from "lodash";
import VirtualCSSGrid from "react-virtual-css-grid";

const library: LibraryLayer[] = [];

export interface Directory {
  name: string;
  path: string;
  img: string;
  url?: string;
}

const categories: any = {
  "": {
    name: "root",
    items: [
      {
        path: "/countries",
        name: "Countries",
        img: "/library/countries/world.png"
      },
      {
        path: "/us-states",
        name: "US States & Territories",
        img: "/library/USStates/us-state-terr.png"
      },
      {
        path: "/us-counties",
        name: "US Counties",
        img: "/library/USCounties/us-counties.png"
      }
    ]
  }
};

const getGridStyle = {
  // gridGap: "10px",
  // gridTemplateColumns: "repeat(3, 1fr)",
  // padding: "3px"
  gridGap: "5px",
  // justifyContent: "space-evenly",
  gridTemplateColumns: "repeat(3, 1fr)"
};

const getCointainerStyle = {
  // height: "70vh",
  // width: "100%"
  height: "70vh",
  textAlign: "center"
};

export const pathLookup: any = { ...categories, ...countries };

function Library() {
  const { addLayer, view, setView, setShowLibrary, showLibrary } = useContext(
    State
  );
  const [path, setPath] = useState([] as string[]);
  const [search, setSearch] = useState("");
  const rootClick = () => setPath([]);
  const pathStr = path.join("");

  const libraryBase = (e: string) =>
    `https://raw.githubusercontent.com/DrewWeth/geodebugger-library/master/library/${e}`;
  const addIt = (e: string) => {
    getLayer({ e: libraryBase(e), addLayer, view, setView });
  };

  const pushDir = (e: Directory) => {
    const newArr = [...path, e.path];
    setPath(newArr);
  };

  const searchLowercase = search.toLowerCase();
  const cards = (_.get(pathLookup[pathStr], ["items"]) || []).filter(
    (a: any) => a.name.toLowerCase().indexOf(searchLowercase) >= 0
  );

  const renderGridItem = (props: any) => {
    const { position, columnPosition, rowPosition, scrollRatio } = props;
    //  defining some styles for the grid item
    //  only gridRowStart and gridColumnStart will be overwritten
    //	returning one div as gridItem
    if (position > cards.length - 1) {
      return <div />;
    } else {
      const e = cards[position];
      return (
        <Link
          key={`${search}-${position}`}
          onClick={() => {
            e.url ? addIt(e.url) : pushDir(e);
          }}
        >
          <LibraryCard card={e} i={position} />
        </Link>
      );
    }
    // const i = position > cards.length - 1 ? () cards.length - 1 : position;
  };

  return (
    <>
      <div className="content radius-all shadow library-holder">
        <div
          style={{
            marginBottom: 20,
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <div>
            <Link onClick={rootClick}>root</Link>
            {path.length > 0 && pathStr}
          </div>
          <Link onClick={() => setShowLibrary(false)}>Close</Link>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>Layer Library</div>
          <div>
            <input
              placeholder="Search"
              type="string"
              value={search}
              onChange={a => setSearch(a.target.value)}
            />
          </div>
          <div>{cards.length} resources</div>
        </div>
        <hr></hr>
        <VirtualCSSGrid
          key={`${search}-${path}`}
          //  the function that renders each gridItem
          //  required
          renderGridItem={renderGridItem}
          //  how many itens we have on our grid
          //  required
          nItems={cards.length + (3 - (cards.length % 3))}
          //  some optional fields:
          //  the container style (recommended)
          style={getCointainerStyle}
          //  the grid style (goes as a div and child of the container)
          //  also recommended
          gridStyle={getGridStyle}
        />
        {/* </div> */}
      </div>
    </>
  );
}

export default Library;
